import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";

// Canonical job id
const pickJobId = (job) => job?.jobId ?? job?.id ?? job?._id ?? "";

const pick = (job, key, fallbacks = []) => {
  for (const k of [key, ...fallbacks]) {
    const v = job?.[k];
    if (v !== undefined && v !== null) return v;
  }
  return "";
};

const Candcard = ({ job }) => {
  const navigate = useNavigate();

  const jobId = pickJobId(job);
  const positionTitle = pick(job, "positionTitle", ["title", "name"]) || "—";
  const department =
    pick(job, "department", ["jobDepartment", "category"]) ||
    "Information Technology";
  const org =
    pick(job, "organisationName", ["organization", "organisation", "company"]) ||
    "MTN Rwanda";
  const city = pick(job, "city", ["locationTown", "town"]) || "Kigali";
  const region = pick(job, "region", ["location", "province"]) || "Rwanda";
  const mtnLevel = pick(job, "mtnLevel", ["level", "grade"]) || "";
  const deadlineRaw = pick(job, "applicationDeadline", ["deadline", "closingDate"]);
  const deadline = deadlineRaw
    ? new Date(deadlineRaw).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";

  const handleDetailsClick = () => {
    if (!jobId) return;
    navigate(`/jobs/${jobId}/candidates`);
  };

  const handleEditClick = () => {
    if (!jobId) return;
    navigate(`/career/edit/${jobId}`);
  };

  return (
    /* same tall card, but constrained to 800px and centered */
    <div className="max-w-[800px] w-full mx-auto flex items-center justify-between bg-gradient-to-r from-white via-gray-100 to-gray-200 rounded-2xl px-6 py-6 shadow-sm hover:shadow-md transition-all duration-200">
      {/* Left content (logo removed) */}
      <div className="flex flex-col">
        <h3 className="text-xl sm:text-2xl font-extrabold text-gray-900 leading-7">
          {positionTitle}
        </h3>
        <p className="text-sm text-gray-600 mt-1">
          {org} • {department} • {city}, {region}
        </p>

        <div className="flex items-center gap-4 text-sm text-gray-700 mt-2">
          {mtnLevel && <span>• {mtnLevel}</span>}
          <span className="flex items-center gap-2">
            <FaCalendarAlt className="text-yellow-500" />
            {deadline ? `Deadline: ${deadline}` : "—"}
          </span>
        </div>
      </div>

      {/* Right CTA */}
      <div className="flex flex-col sm:flex-row items-center gap-2">
        <button
          onClick={handleEditClick}
          disabled={!jobId}
          className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-150 shadow-sm ${
            jobId
              ? "bg-white text-gray-900 border border-gray-300 hover:bg-gray-50 hover:shadow-md"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
        >
          Edit Job
        </button>

        <button
          onClick={handleDetailsClick}
          disabled={!jobId}
          className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-150 shadow-sm ${
            jobId
              ? "bg-[#FFCC00] text-gray-900 hover:bg-yellow-500 hover:shadow-md"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
        >
          View Candidates
        </button>
      </div>
    </div>
  );
};

export default Candcard;
